import React, { RefObject } from 'react';
import magicPen from '../../assets/magic.svg';
import EmojiPickerInput from '../../components/EmojiPickerInput';

type Props = {
    content: string;
    textareaRef: RefObject<HTMLTextAreaElement>;
    setContent: React.Dispatch<React.SetStateAction<string>>;
    handleCursorPosition: (event: any) => void;
    handleAIModal: (event: React.MouseEvent<HTMLButtonElement>) => void;
    handleTagChange: (e: React.ChangeEvent<HTMLSelectElement>, networkKey?: string) => void;
    selectedTag: string;
    isUserSso: boolean;
    tags: string[];
    emoji: string;
    isViewOnly: boolean;
    error: string | null;
    isErrorVisible: boolean;
};

export function ContentPublicationInput({
    content,
    textareaRef,
    setContent,
    handleCursorPosition,
    handleAIModal,
    handleTagChange,
    selectedTag,
    isUserSso,
    tags,
    emoji,
    isViewOnly,
    error,
    isErrorVisible,
}: Props) {
    return (
        <div className="w-[calc(100%-340px)]">
            <label htmlFor="content">Contenu de la publication</label>
            <textarea
                className="rounded-t-[5px] h-[258px] w-full"
                ref={textareaRef}
                name="content"
                value={content}
                onChange={e => setContent(e.target.value)}
                onClick={handleCursorPosition}
                onKeyUp={handleCursorPosition}
                placeholder="Contenu de la publication"
                required
                readOnly={isViewOnly}
            />
            {error && (
                <div className="text-[#d32f2f] bg-[#fddede] border border-[#fbc2c4] rounded-[4px] p-[10px] m-[20px] text-[0.9em] gap-[20px]">
                    {error}
                </div>
            )}
            {isErrorVisible && (
                <div className="text-[#d32f2f] bg-[#fddede] border border-[#fbc2c4] rounded-[4px] p-[10px] m-[20px] text-[0.9em] gap-[20px]">
                    Votre quota de génération de contenu par IA est atteint. Merci de contacter le
                    support.
                </div>
            )}
            <div className="flex relative justify-end items-center h-auto min-h-[66px] px-0 py-[11px] border border-t-0 border-light-gray rounded-b-[5px] w-[calc(100%-2px)] bg-primary-light">
                <button
                    className="flex items-center bg-transparent text-small font-medium pr-[12px]"
                    type={'button'}
                    disabled={isViewOnly}
                    onClick={handleAIModal}
                >
                    <img className="w-5" src={magicPen} alt="baguette magique" />
                    Générer du contenu avec l'IA
                </button>
                {!isUserSso && (
                    <select
                        onChange={handleTagChange}
                        value={selectedTag}
                        disabled={isViewOnly}
                        className={
                            'appearance-none font-montserrat text-small font-medium bg-primary-light border-none w-auto flex'
                        }
                    >
                        <option value="">@ Balises</option>
                        {tags.map((tag, index) => (
                            <option key={index} value={tag}>
                                {tag}
                            </option>
                        ))}
                    </select>
                )}
                {!isViewOnly && (
                    <EmojiPickerInput
                        value={content}
                        onChange={setContent}
                        inputRef={textareaRef}
                        pickerPosition="bottom-full"
                        buttonContent={
                            <>
                                <img
                                    src={emoji}
                                    className="inline-block w-[20px] h-[20px] mr-[5px]"
                                    alt="emoji icon"
                                />
                                <span className="font-montserrat pr-[12px] font-medium">Emoji</span>
                            </>
                        }
                    />
                )}
            </div>
        </div>
    );
}
